


import { Component, Vue } from "vue-property-decorator";

/* La liste du Desktop ( `Web/Libs/Helpers`, champs des fiches contact et du
   conseiller ), relevee a l'ecran le 21/10/2026 : la Console n'a pas ces fiches.
   Une variable ajoutee la-bas est a reporter ici. */
interface VariableEntry {
    Fr: string;
    En: string;
    Token: string;
}

const VARIABLES: { Id: string; Name: string; Variables: VariableEntry[] }[] = [
    { Id: "natural", Name: "NEWSLETTERS_variablesNatural", Variables: [
        { Fr: "Civilité", En: "Civility", Token: "{natural_person.civility}" },
        { Fr: "Prénom", En: "First name", Token: "{contact.firstname}" },
        { Fr: "Nom", En: "Last name", Token: "{contact.lastname}" },
        { Fr: "Adresse", En: "Address", Token: "{natural_person.deliveryAddress}" },
        { Fr: "E-mail", En: "Email", Token: "{natural_person.email}" },
        { Fr: "Téléphone", En: "Phone", Token: "{natural_person.phoneNumber}" },
        { Fr: "Observations", En: "Comments", Token: "{contact.comment}" },
        { Fr: "Naissance", En: "Birthday", Token: "{natural_person.birthday}" },
        { Fr: "Situation familiale", En: "Marital status", Token: "{natural_person.situation}" },
        { Fr: "Fonction", En: "Job", Token: "{natural_person.job}" },
        {
            Fr: "Enfants à charge",
            En: "Dependent children",
            Token: "{natural_person.childrenInCharge}"
        }
    ] },
    { Id: "legal", Name: "NEWSLETTERS_variablesLegal", Variables: [
        { Fr: "Nom commercial", En: "Trade name", Token: "{legal_entity.name}" },
        { Fr: "Adresse", En: "Address", Token: "{legal_entity.deliveryAddress}" },
        { Fr: "E-mail", En: "Email", Token: "{legal_entity.email}" },
        { Fr: "Téléphone", En: "Phone", Token: "{legal_entity.phoneNumber}" },
        { Fr: "Secteur d'activité", En: "Industry", Token: "{legal_entity.industry}" },
        { Fr: "Observations", En: "Comments", Token: "{contact.comment}" },
        { Fr: "Site web", En: "Website", Token: "{legal_entity.website}" }
    ] },
    { Id: "owner", Name: "NEWSLETTERS_variablesOwner", Variables: [
        { Fr: "Prénom", En: "First name", Token: "{contact_owner.firstname}" },
        { Fr: "Nom", En: "Last name", Token: "{contact_owner.lastname}" },
        { Fr: "Téléphone", En: "Phone", Token: "{contact_owner.phoneNumber}" },
        { Fr: "E-mail", En: "Email", Token: "{contact_owner.email}" },
        { Fr: "Signature", En: "Signature", Token: "{contact_owner.signature}" },
        {
            Fr: "Point de vente nom",
            En: "Sale point name",
            Token: "{contact_owner.salePoint.name}"
        },
        {
            Fr: "Point de vente adresse",
            En: "Sale point address",
            Token: "{contact_owner.salePoint.address}"
        },
        {
            Fr: "Point de vente téléphone",
            En: "Sale point phone",
            Token: "{contact_owner.salePoint.phoneNumber}"
        },
        {
            Fr: "Point de vente e-mail",
            En: "Sale point email",
            Token: "{contact_owner.salePoint.email}"
        },
        {
            Fr: "Point de vente site web",
            En: "Sale point website",
            Token: "{contact_owner.salePoint.websiteUrl}"
        },
        {
            Fr: "Point de vente carte professionnelle",
            En: "Sale point professional card",
            Token: "{contact_owner.salePoint.professionalCard}"
        }
    ] },
    /* La date de l'envoi ( reponse back du 26/10/2026 ), comme au Desktop. */
    { Id: "date", Name: "NEWSLETTERS_variablesDate", Variables: [
        { Fr: "Jour", En: "Day", Token: "{date.day}" },
        { Fr: "Mois", En: "Month", Token: "{date.month}" },
        { Fr: "Mois et année", En: "Month and year", Token: "{date.month_year}" },
        { Fr: "Année", En: "Year", Token: "{date.year}" }
    ] }
];

interface VariableGroup {
    Id: string;
    Name: string;
    Variables: { Name: string; Token: string }[];
}

/* LES VARIABLES DU SUJET ( Fred, 21/10/2026 : « un systeme qui nous permette de
   les retrouver, de faire un copier-coller et de les ajouter » ).

   Les memes variables que la barre des editeurs d'e-mail ( `Web/Libs/Helpers`,
   `SubstitutionVariables` du PB e-mail ) : le contact personne, le contact
   societe, son conseiller. L'API les remplace a l'envoi avec le meme analyseur
   que les campagnes ( `BaseParser` ).

   Un clic sur une ligne l'AJOUTE au sujet ( evenement `Insert` ) ; l'icone de
   droite la COPIE. La liste s'ouvre sous le bouton, se ferme au clic a cote ou a
   Echap — meme comportement que les listes des destinataires. */
@Component
export default class VariablePicker extends Vue {
    private open: boolean = false;
    private keyword: string = "";
    private copied: string = "";

    mounted(): void {
        document.addEventListener( "mousedown", this.onOutside );
    }

    beforeDestroy(): void {
        document.removeEventListener( "mousedown", this.onOutside );
    }

    private onOutside( event: MouseEvent ): void {
        if( !this.$el.contains( event.target as Node ) )
            this.open = false;
    }

    private get groups(): VariableGroup[] {
        const english = String( this.$i18n.locale ).toLowerCase().indexOf( "en" ) === 0;
        const keyword = this.keyword.trim().toLowerCase();

        return VARIABLES
            .map( group => ( {
                Id: group.Id,
                Name: this.$t( group.Name ).toString(),
                Variables: group.Variables
                    .map( variable => ( {
                        Name: english ? variable.En : variable.Fr,
                        Token: variable.Token
                    } ) )
                    .filter( variable => keyword === "" ||
                        variable.Name.toLowerCase().indexOf( keyword ) >= 0 ||
                        variable.Token.toLowerCase().indexOf( keyword ) >= 0 )
            } ) )
            .filter( group => group.Variables.length > 0 );
    }

    private insert( token: string ): void {
        this.$emit( "Insert", token );
        this.open = false;
        this.keyword = "";
    }

    private async copy( token: string ): Promise<void> {
        try {
            await navigator.clipboard.writeText( token );
            this.copied = token;
            window.setTimeout( () => {
                if( this.copied === token )
                    this.copied = "";
            }, 1500 );
        } catch( _ ) {
            this.copied = "";
        }
    }
}
